module.exports = __webpack_public_path__ + "static/img/ic_release_success.baa2e77f.png";